<template>
<!-- contents -->
<div id="contents">
    <div class="contents_wrap">
        <!-- contents_head -->
        <!-- breadcrumbs -->
        <skp-breadcrumbs @page-title="val => pageTitle = val" />
        <!-- //breadcrumbs -->
        <h2 class="pg_title">{{ pageTitle }}</h2>
        <!-- //contents_head -->

        <!-- srchTop_wrap -->
        <div class="srchTop_wrap srch_mypage">
            <article class="srch_detail">
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.MENU') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_2">
                            <div>
                                <select
                                    id="BOARD_TYPE1"
                                    name="BOARD_TYPE1"
                                    v-model="BOARD_TYPE1"
                                    class="slt_white w100p"
                                    @change="changeBoardType1($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option v-show="boardType1List.length > 0"
                                            v-for="item in boardType1List"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select
                                    id="BOARD_TYPE2"
                                    name="BOARD_TYPE2"
                                    v-model="BOARD_TYPE2"
                                    class="slt_white w100p"
                                    @change="changeBoardType2($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                                    <option v-show="boardType2List.length > 0"
                                            v-for="item in boardType2List"
                                            :key="item.code"
                                            :value="item.code"
                                            :data-menu-grp-dtl-cd="item.menuGrpDtlCd"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_select">
                    <dt>{{ $t('FIELD.GLOBAL.CATEGORY') }}</dt>
                    <dd data-input-type="select">
                        <!-- 200715수정 S -->
                        <fieldset class="ui_fieldset set_3">
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD1"
                                        v-model="PRD_CATEGORY_CD1"
                                        @change="changeCategory1($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList1.length > 0"
                                            v-for="item in categoryComboList1"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD2"
                                        v-model="PRD_CATEGORY_CD2"
                                        @change="changeCategory2($event)"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList2.length > 0"
                                            v-for="item in categoryComboList2"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                            <div>
                                <select class="slt_white w100p"
                                        id="PRD_CATEGORY_CD3"
                                        v-model="PRD_CATEGORY_CD3"
                                >
                                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTCATEGORY') }}</option>
                                    <option v-show="categoryComboList3.length > 0"
                                            v-for="item in categoryComboList3"
                                            :key="item.code"
                                            :value="item.code"
                                    >{{item.codeName}}</option>
                                </select>
                            </div>
                        </fieldset>
                    </dd>
                </dl>
                <dl class="dl_search">
                    <dt>{{ $t('FIELD.GLOBAL.STATUS') }}</dt>
                    <dd data-input-type="select">
                        <select class="slt_white w100p"
                                id="searchStatus"
                                v-model="searchStatus"
                        >
                            <option value="" selected>{{ $t('FIELD.GLOBAL.ALL') }}</option>
                            <option v-show="statusComboList.length > 0"
                                    v-for="item in statusComboList"
                                    :key="item.code"
                                    :value="item.code"
                            >{{item.codeName}}</option>
                        </select>
                    </dd>
                    <dd class="clearable" data-input-type="input">
                        <input  id="searchTitle"
                                name="searchTitle"
                                type="text"
                                class="text_input w100p"
                                maxlength="200" 
                                v-model.trim="searchTitle"
                                :placeholder="$t('FIELD.PLACEHOLDER.KNOWLEDGE.RESULTSEARCH')"
                                @keyup.enter.stop="handleSearch"
                                v-clearable
                        >
                        <i class="clearable_clear">{{ $t('BUTTON.GLOBAL.DELETE') }}</i>
                    </dd>
                </dl>
                <!-- 200714수정 S -->
                <span class="srch_mypage_btn">
                    <a href="javascript:" class="btn_srch" @click="handleSearch">{{ $t('FIELD.GLOBAL.SEARCH') }}</a>
                </span>
            </article>
        </div>

        <!-- Grid -->
        <div class="grid_wrap" v-resize="setGridResizeColumn">
            <bug-report-grid
                :gridId="gridId"
                :ref="gridId"
                :columns="columns"
                :data="gridData"
                :options="options"
                :pageOptions="pageOptions"
                :isTotalCount="true"
                :click="contentClick"
                @grid-total-count="setTotalCount"
            />
            <div class="paginate">
                <sdl-pagination
                    align="center"
                    :current-page="currentPage"
                    :total-rows="totalCount"
                    :per-page="perPage"
                    @change="movePage"
                />
            </div>
        </div>
    </div>
</div>
<!-- contents -->
</template>
<script>
import Vue                                  from 'vue';
import axios                                from 'axios';
import qs                                   from 'query-string';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import resize                               from 'vue-resize-directive'
import api                                  from '@/service';
import store                                from '@/vuex/store';
import constants                            from '@/constants';
import SDLLocale                            from '@/mixin/SDLLocale';
import SDLPagination                        from '~~c/control/pagination/Pagination';
import { SDLUtil, MenuUtil, StringUtil }    from '@/utils';
import { EventBus }                         from '@/utils/EventBus';

import DatePicker                           from '~c/DatePicker';

import SKPBreadcrumbs                       from '~vb/main/SKPBreadcrumbs';

import BugReportListGrid                    from './BugReportListGrid';

const fetchCodeCombo = (codeCategoryId, categoryId, symptomType, symptom1) => axios.get(
    `${SDLUtil.API_URL}/basis/common/codeAjax.skp?`
  + `codeCategoryId=${codeCategoryId}`
  + `&categoryId=${categoryId}`
  + `&symptomType=${symptomType}`
  + `&symptom1=${symptom1}`
  + `&parentCode=1`
);

export default {
    name: 'BugReportList',
    data() {
    	return {
            pageTitle: '',

            BOARD_TYPE1: '',            // board Type - board parent id
            BOARD_TYPE2: '',            // board Type - board id
            boardType1List: [],         // board Type List 1
            boardType2List: [],         // board Type List 2

            PRD_CATEGORY_CD1: '',       // Category 1
            PRD_CATEGORY_CD2: '',       // Category 2
            PRD_CATEGORY_CD3: '',       // Category 3
            categoryComboList1: [],     // Category 1 List
            categoryComboList2: [],     // Category 2 List
            categoryComboList3: [],     // Category 3 List
            qCategory1: '',             // Quick Category Value 1
            qCategory2: '',             // Quick Category Value 2
            qCategory3: '',             // Quick Category Value 3

            searchStatus: '',           // Status
            statusComboList: [],        // Status List

            searchTitle: '',            // Subject

            gridId: 'myBugReportGrid',
            columns: [],
            options: {},
            pageOptions: {},
            gridData: [],

            totalCount: 0,
            pageNo: 1,
            currentPage: 1,
            perPage: localStorage.getItem('listRows') ? Number(localStorage.getItem('listRows')) : 10
    	}
    },
    computed: {
        ...mapGetters({
            userRoles: 'getRoles',
            userCorpCd: 'getCorpCd',
            params: 'getParams',
            locale: 'getLocale',
            menus: 'getMenus',
        }),
        getUserInfo()           { return SDLUtil.getLoginedUserInfo() || {}; },
        getUserRole()           { return this.userRoles || []; },
        getUserCorpCd()         { return this.userCorpCd || ''; },
        getBoardCreationYN()    { return this.params.creationYn || 'N'; },
        getScrapWorkCode()      { return MenuUtil.getScrapWorkCode(); },
        getSelBoardType1()      { return this.BOARD_TYPE1 || ''; },
        getSelBoardType2()      { return this.BOARD_TYPE2 || ''; },
        getSelCategory1()       { return (!SDLUtil.isNull(this.qCategory1)) ? this.qCategory1 : this.PRD_CATEGORY_CD1 || ''; },
        getSelCategory2()       { return (!SDLUtil.isNull(this.qCategory2)) ? this.qCategory2 : this.PRD_CATEGORY_CD2 || ''; },
        getSelCategory3()       { return (!SDLUtil.isNull(this.qCategory3)) ? this.qCategory3 : this.PRD_CATEGORY_CD3 || ''; },
        getReSearch()           { return this.$route.query.reSearch || 'N'; },
        getPageNo()             { return this.pageNo; },
    },
    directives: { resize },
    components: {
        'skp-breadcrumbs'   : SKPBreadcrumbs,
        'sdl-pagination'    : SDLPagination,
        'bug-report-grid'   : BugReportListGrid,
    },
    methods: {
        // 처음 로딩 시
        initLoad() {
            SDLUtil.showLoadingBar(true);
            // 그리드 컬럼 세팅
            this.columns = this.getDynamicCols();
            // 게시판 타입 1 로드
            this.setBoardType1().then(() => { this.setBoardType2(); });
            // 초기 카테고리1 리스트 로드
            this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                this.categoryComboList1 = data;
            });
            // 초기 상태 리스트 로드
            this.setStatusList();
            SDLUtil.showLoadingBar(false);

            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // Code combo list api
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getUserCorpCd);
            return codeResp;
        },
        // Board1 setting
        setBoardType1() {
            this.getCodeComboList(this.getUserCorpCd, "BOARD_TYPE1").then(data => {
                this.BOARD_TYPE1    = this.getSelBoardType1;
                this.boardType1List = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // Board2 setting
        setBoardType2() {
            this.getCodeComboList(this.getSelBoardType1, "BOARD_TYPE2").then(data => {
                this.BOARD_TYPE2    = this.getSelBoardType2;
                this.boardType2List = data;
            });
        },
        // Board1 combo change event => create Board2 combo list
        changeBoardType1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.boardType2List = [], this.BOARD_TYPE2 = '';

            } else {
                this.getCodeComboList(comboValue, "BOARD_TYPE2").then(data => {
                    this.boardType2List = data;
                    this.BOARD_TYPE2    = '';
                });
            }
        },
        // Board2 combo change event
        changeBoardType2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue !== "") {
                let selMenuGrpDtlCd = document.getElementById('BOARD_TYPE2').selectedOptions[0].getAttribute('data-menu-grp-dtl-cd');
                this.setSCMSField(this.getMenuGrpDtlCd);

            } else {
                this.isSCMS = false;
            }
        },
        // SCMS 필드 사용 여부 + Repair tip 메뉴 여부
        setSCMSField(menuGroupDetailCd = this.params.menuGrpDetailCd) {
            // Service Bulletin, Repair Tip, Call Guide, Repeated Repair Tip => isSymptom true
            if(menuGroupDetailCd !== null) {
                // SCMS Contents 이어야 하고 Board 를 통한 접근이 아니어야 함
                if( _.includes(SCMS_CONTENTS_CD, menuGroupDetailCd)
                 && !this.isBoardAccess
                ) {
                    if(menuGroupDetailCd === 'RT') this.isRepair = true;
                    this.isSCMS = true;

                } else {
                    this.isRepair = false;
                    this.isSCMS = false;
                }

            } else {
                this.isRepair = false;
                this.isSCMS = false;
            }
        },
        // 첫번째 카테고리 설정
        setCategory1() {
            this.getCodeComboList(this.getSelCategory1, "ADM_CATEGORY_B").then(data => {
                this.PRD_CATEGORY_CD1   = this.getSelCategory1;
                this.categoryComboList2 = data;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 두번째 카테고리 설정
        setCategory2() {
            this.getCodeComboList(this.getSelCategory2, "ADM_CATEGORY_C").then(data => {
                this.PRD_CATEGORY_CD2   = this.getSelCategory2;
                this.categoryComboList3 = data;
                this.PRD_CATEGORY_CD3   = this.getSelCategory3;
            });

            let that = this;
            return new Promise(function(resolve) {
                setTimeout( function(){ resolve(); }, 100 );
            });
        },
        // 첫번째 카테고리 변경 이벤트
        changeCategory1(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList2 = [], this.PRD_CATEGORY_CD2 = '';
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = [], this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = [], this.symptomList[idx].SYMPTOM_TYPE1    = '';
                }

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_B").then(data => {
                    this.PRD_CATEGORY_CD2 = '';
                    this.categoryComboList2 = data;
                });

                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
            }
        },
        // 두번째 카테고리 변경 이벤트
        changeCategory2(e) {
            let comboValue = StringUtil.getComboboxValue(e.target.id);
            if(comboValue == "") {
                this.categoryComboList3 = [], this.PRD_CATEGORY_CD3 = '';
                for(let idx = 0; idx < this.symptomList.length; idx++){
                    this.symptomList[idx].SYMPTOM_TYPEList   = [], this.symptomList[idx].SYMPTOM_TYPE     = '';
                    this.symptomList[idx].SYMPTOM_TYPE1List  = [], this.symptomList[idx].SYMPTOM_TYPE1    = '';
                }

            } else {
                this.getCodeComboList(comboValue, "ADM_CATEGORY_C").then(data => {
                    this.PRD_CATEGORY_CD3 = '';
                    this.categoryComboList3 = data;
                });
            }
        },
        // Status Combo list
        setStatusList() {
            SDLUtil.getCommCodeList('BUG_STATUS').then(data => {
                this.searchStatus = '';
                this.statusComboList = data;
            });
        },
        // 그리드 컬럼 percent resize 용
        getDynamicCols() {
            return [
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.SUBJECT'), name: 'KNOWLEDGE_TITLE', align: 'left', width: this.getColumnSize(30), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.OPINION'), name: 'REPORT_DESC', align: 'left', width: this.getColumnSize(35), resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.REGISTERED.BY'), name: 'REG_USER_NM', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: false },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.DATE'), name: 'REG_DT', align: 'center', width: this.getColumnSize(15), resizable: true, sortable: true },
                { header: SDLUtil.getMsgProp('FIELD.GLOBAL.STATUS'), name: 'STATUS_NM', align: 'center', width: this.getColumnSize(10), resizable: true, sortable: true },
                { header: 'BUG_REPORT_ID', name: 'BUG_REPORT_ID', hidden: true },
            ];
        },
        getColumnSize(size) {
            if(isNaN(Number(size))) { return 0; }
            let gridWrapSize = document.getElementsByClassName('grid_wrap').length ? document.getElementsByClassName('grid_wrap')[0].clientWidth - 16 : 1000;
            return Math.floor(gridWrapSize / (100 / size));
        },
        setGridResizeColumn(e) {
            EventBus.$emit('bug-grid-set-column', this.getDynamicCols());
        },
        // 그리드 컬럼 percent resize 용

        // 페이지 이동
        movePage(pageNo) {
            this.currentPage = pageNo;
            this.handlePageSearch(pageNo);
        },
        // 총 합계 설정
        setTotalCount(totCnt) {
            this.totalCount = totCnt;
        },
        // 현재 페이지 설정
        setCurrentPage(page) {
            this.currentPage = page;
        },

        // Search Parameter setting
        setSearchParameter() {
            this.searchTitle = (SDLUtil.nvl(this.searchTitle)).toUpperCase();

            return {
                BOARD_TYPE1: this.getSelBoardType1,
                BOARD_TYPE2: this.getSelBoardType2,
                PRD_CATEGORY_CD1: this.PRD_CATEGORY_CD1 || '',
                PRD_CATEGORY_CD2: this.PRD_CATEGORY_CD2 || '',
                PRD_CATEGORY_CD3: this.PRD_CATEGORY_CD3 || '',
                searchStatus: this.searchStatus,
                searchTitle: this.searchTitle,
                ORDER_COLUMN: this.ORDER_COLUMN || '',
                ORDER_ASC: this.ORDER_ASC || '',
                page: this.getPageNo
            }
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            if(!SDLUtil.isNull(sortObj.orderColName)) {
                this.ORDER_COLUMN = sortObj.orderColName;
                this.ORDER_ASC = sortObj.ascending ? "ASC" : "DESC";
            } else {
                this.ORDER_COLUMN = '';
                this.ORDER_ASC = '';
            }

            this.handlePageSearch(1);
        },
        // 페이지 조회
        handlePageSearch(pageNo){
            if(pageNo !== null && pageNo != "") {
                this.pageNo = pageNo;
                this.handleSearch();

            } else {
                Vue.$log.warn('Page no is null');
            }
        },
        // 조회
        handleSearch() {
            // Call BugReportListGrid.vue > loadData method
            EventBus.$emit('bug-grid-search', this.setSearchParameter());
        },
        // 재조회
        reSearch(pageNo) {
            // this.setCategoryParam(boardParam.searchParams);
            this.pageNo = pageNo;
            this.handlePageSearch(pageNo);
        },
        // 컨텐츠 클릭 이벤트
        contentClick(e, rowData, grid) {
            let colNm = e.columnName;
            if ((typeof e.rowKey) === "undefined") return;
            let row = rowData.find(function(r){ return r.rowKey === e.rowKey });
            let bugReportId = row['BUG_REPORT_ID'] || '';
            Vue.$log.info('▶ BugReportList.vue contentClick event. =>', row, bugReportId);

            if(bugReportId !== null) {
                window.scrollTo(0, 0);
                const params = {
                    BUG_REPORT_ID: bugReportId
                };

                return this.$router.push({ name: 'MyBugReportDetail', query: params });
            }
        },

        // Quick Category Parameter setting
        setQuickCategoryParam(catForm) {
            this.initCategoryParam();
            this.qCategory1 = catForm.searchPRD_CATEGORY_CD1;
            this.qCategory2 = catForm.searchPRD_CATEGORY_CD2;
            this.qCategory3 = catForm.searchPRD_CATEGORY_CD3;

            this.changeCategories();
        },
        // 카테고리 파라미터 초기화
        initCategoryParam() {
            this.qCategory1 = '';
            this.qCategory2 = '';
            this.qCategory3 = '';
            this.PRD_CATEGORY_CD1 = '';
            this.PRD_CATEGORY_CD2 = '';
            this.PRD_CATEGORY_CD3 = '';
            this.categoryComboList1 = [];
            this.categoryComboList2 = [];
            this.categoryComboList3 = [];
        },
        // 모든 카테고리 변경 이벤트, 처음 Mounted 혹은, quick category 를 click 했을 때 호출
        changeCategories() {
            this.setCategory1().then(() => {
                this.setCategory2().then(() => {
                    this.getCodeComboList("0", "ADM_CATEGORY_A").then(data => {
                        this.categoryComboList1 = data;
                    });
                });
            });
        },
    },
    created() {
        this.initLoad().then(() => {
            Vue.$log.info('▶ BugReportList.vue created.');
            EventBus.$on('page-search',    pageNo   => { this.handlePageSearch(pageNo); });
            EventBus.$on('sort-search',    sortForm => { this.handleSortSearch(sortForm); });
            EventBus.$on('quick-category', catForm  => { this.setQuickCategoryParam(catForm); });
        });
    },
    mounted() {
        /* DOM 생성 후 이벤트
        this.$nextTick(() => {
            this.searchTitle = this.$route.query.searchTitle;
        });
        */
    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('page-search');
        EventBus.$off('sort-search');
        EventBus.$off('quick-category');
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/myKnowledge/bugReport/BugReportList.vue